export class ELookup{
    public static readonly AdmissionStatusType = 'admst';
    public static readonly AdmissionTerm = 'admtrm';
    public static readonly CorrespondanceType = 'corrt';
    public static readonly CourseType = 'court';
    public static readonly ExamType = 'exmt';
    public static readonly MajorDiscipline = 'mjrd';
    public static readonly Race = 'race';
    public static readonly Residence = 'resi';
    public static readonly SportType = 'sprt';
    public static readonly Sex = 'sx';
    public static readonly Reason = 'witd';
    public static readonly Legislations = 'lgen'; // Modifications required.
    public static readonly States = 'lgen'; // Modifications required.
    public static readonly Institution = 'instn';
    public static readonly InstitutionTerm = 'instntr';
    public static readonly StudentEnrollmentType = 'sentt';
    public static readonly SportEligibilityType = 'selgt';
    public static readonly FinancialAidAwardExemptionType = 'faaet';
    public static readonly FinancialAidAwardType = 'faat';
    public static readonly SportParticipationType = 'spt';
    public static readonly SportSeason = 'ss';
    public static readonly AthleticFinancialAidRenewalType = 'afart';
    public static readonly FTR = 'fqt';
    public static readonly RedShirtType = 'redshirt';
    public static readonly NoteType = 'nt';
    public static readonly DocumentType = 'dt';
    public static readonly DocumentSourceType = 'dst';
    public static readonly College = 'clg';
    public static readonly UserColleges = 'uclg';
    public static readonly MajorConcentration = 'mgcon';
    public static readonly OfficialVisitReason = 'offvr';
    public static readonly HouseType = 'ht';
    public static readonly LetterStatus = 'ls';
    public static readonly NonAthleticAidAwardType = 'naaat';
    public static readonly NonAthleticFinancialAidCountableStatus = 'nafacs';
    public static readonly BoardPlanType = 'bpt';
    public static readonly AddressType = 'at';
    public static readonly EmailType = 'et';
    public static readonly PhoneType = 'pt';
    public static readonly ProspectAdmissionStatusType = 'past';
    public static readonly AcademicProgressRateEligibilityType = 'aprelgt';
    public static readonly AcademicProgressRateExclusionType = 'aprext';
    public static readonly AcademicProgressRateRetentionType = 'aprrt';
    public static readonly State = 'state';
    public static readonly CoverLetterType = 'coverletter';
 }
